// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"275e88920da5a989e057","655":"57fe4e020359af59063e"}[chunkId] + ".js";
};